import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'Yrix Park';
  
  constructor(private translate: TranslateService) {
    // Configurar español como idioma predeterminado a nivel de aplicación
    translate.setDefaultLang('es');
    translate.use('es');
  }
}
